import EzModalController from 'layouts/modal/modal-controller';

export default class EmailVerificationModalController extends EzModalController {
  static targets = [
    'emailVerification',
  ];

  connect() {
    super.connect();

    this.flagLoaded();
  }

  disconnect() {
    super.disconnect();
  }

  close = (event) => {
    super.close(event, () => {}, this.dismissAfterUserClose);
  }

  dismissAfterUserClose = (event) => {
    // we only want to fire the dismiss action if the user manually closes the modal
    if (event.currentTarget.getAttribute('data-action').includes('email-verification-modal#close')) {
      const userId = this.emailVerificationTarget.getAttribute('data-user-id');

      Turbolinks.visit(`/signup/email_verification/dismiss/${userId}`);
    }
  }
}
